import { useMemo } from "react";
import { twJoin } from "tailwind-merge";
import { Skeleton } from "@components/Skeleton/Skeleton";

const widths = ["w-40", "w-24", "w-32", "w-16"];

export const TransactionInformationModalRowSkeleton: React.FC = () => {
  const randomWidth = useMemo(
    () => [
      widths[Math.floor(Math.random() * widths.length)],
      widths[Math.floor(Math.random() * widths.length)],
    ],
    [],
  );

  return (
    <div className="flex justify-between py-3">
      <Skeleton className={twJoin("h-5", randomWidth[0])} />
      <Skeleton className={twJoin("h-5", randomWidth[1])} />
    </div>
  );
};
